import * as $ from 'jquery';
import { Helper } from "./helper";

export class Register {

    static formSelector: string = 'form';
    static formValidator: JQueryValidation.Validator;
    static verifyCustomerIdInProgress: boolean = false;

    /**
     * init
     */
    static init(): void {
        // setup custom validation
        Helper.setupMustBeTrueValidation();
        Helper.applyCustomValidationToForm(this.formSelector); // must be called _after_ all custom validation has been set up

        // set validator object
        this.formValidator = $(this.formSelector).validate(); // must be set _after_ Helper.applyCustomValidationToForm()

        // click events
        this.setupClickEvents();

        // setup form field validation on focusout event
        Helper.setupValidationOnFocusOut(this.formValidator);
    }

    /**
     * setup click events
     */
    static setupClickEvents(): void {
        Helper.setupCheckboxClickEvent();

        // validate ProfileTermsAccepted on click
        $('#ProfileTermsAccepted, .termsaccepted .checkmark').on('click', (event: JQueryEventObject) => this.validateTermsAcceptedOnClick(event));

        // setup form submit event
        $(this.formSelector).on('submit', (event: JQueryEventObject) => this.handleSubmit(event));
    }

    /**
     * handle form submit event
     * @param event the event
     */
    static handleSubmit(event: JQueryEventObject): void {
        let _that: any = this;

        // 'mustbetrue' custom validation
        if (!this.formValidator !== undefined) {
            (<any>this.formValidator).element($("#ProfileTermsAccepted"));
        }

        // check if form is valid
        if (this.formValidator.checkForm()) {
            // validate customer id
            let customerId: string = <string>$("#CustomerNo").val();

            if (!Helper.isStringNullOrEmpty(customerId)) {
                event.preventDefault();
                let doSubmit: boolean = false;
                this.setVerifyCustomerIdInProgress(true);

                $.ajax({
                    type: "GET",
                    url: "/api/User/validateCustomerId?customerId=" + customerId,
                    cache: false,
                    contentType: "application/json"
                }).done((response: any): void => {
                    let isValid: boolean = response.item1;
                    let errorMessage: string = response.item2;

                    if (!isValid) {
                        if (Helper.isStringNullOrEmpty(errorMessage)) {
                            // an error occured while validating customerId => continue post
                            doSubmit = true;
                        }
                        else {
                            _that.showCustomerIdValidationError(errorMessage);
                            _that.setVerifyCustomerIdInProgress(false);
                        }
                    }
                    else {
                        doSubmit = true;
                    }
                }).fail((xhr: JQueryXHR, ajaxOptions: string, thrownError: string): void => {
                    // an error occured - submit and validate server side
                    doSubmit = true;
                }).then(() => {
                    if (doSubmit) {
                        $("form").off('submit').submit();
                    }
                });
            }
        }
    }

    /**
     * validate ProfileTermsAccepted on click
     * @param event the event object
     */
    static validateTermsAcceptedOnClick(event: JQueryEventObject): void {
        let currentTarget: JQuery<Element> = $(event.currentTarget);

        if (!Helper.isNullOrEmpty(currentTarget)) {
            let checkboxTarget: JQuery<Element> = currentTarget.closest(".checkbox-container").find("#ProfileTermsAccepted");

            if (!Helper.isNullOrEmpty(checkboxTarget) && this.formValidator !== undefined) {
                (<any>this.formValidator).element(checkboxTarget);
            }
        }
    }

    private static setVerifyCustomerIdInProgress(inProgress: boolean) {
        this.verifyCustomerIdInProgress = inProgress;

        if (inProgress) {
            $(".loader").show();
            this.disableSubmitBtn();
        }
        else {
            $(".loader").hide();
            this.enableSubmitBtn();
        }
    }

    private static enableSubmitBtn(): void {
        $("button[type=submit]").removeAttr("disabled");
    }

    private static disableSubmitBtn(): void {
        $("button[type=submit]").attr("disabled", "disabled");
    }

    private static showCustomerIdValidationError(errorMessage: string) {
        let errors: any = { CustomerNo: errorMessage };
        this.formValidator.showErrors(errors);   
    }
}